import { Component, Input } from '@angular/core';
import { ChartConfiguration, ChartDataset } from 'chart.js';

@Component({
  selector: 'bar-chart',
  templateUrl: './bar-chart.component.html',
  styleUrls: ['./bar-chart.component.scss'],
})
export class BarChartComponent {

  readonly type: ChartConfiguration<'bar'>['type'] = 'bar';

  options: ChartConfiguration<'bar'>['options'] = {
    plugins: {
      title: {
        display: false,
        position: 'top',
        text: '',
      },
    },
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        min: 0,
        ticks: {
          precision: 0,
          stepSize: 1,
        }
      },
    }
  };

  @Input() height = 250;
  @Input() backgroundColor?: string;
  @Input() hoverBackgroundColor?: string;

  @Input() set data(data: number[] | undefined) {
    if (data) {
      this.dataset = [{
        data,
        ...(this.backgroundColor && {backgroundColor: this.backgroundColor}),
        ...(this.hoverBackgroundColor && {hoverBackgroundColor: this.hoverBackgroundColor})
      }];
      this.chartData = data;
    }
  };

  @Input() set title(title: string | undefined) {
    if (title) {
      if (!this.options) this.options = {};
      if (!this.options.plugins) this.options.plugins = {};
      if (!this.options.plugins.title) this.options.plugins.title = {};

      this.options.plugins.title.text = title;
    }
  };

  @Input() set inlineTitle(value: boolean) {
    if (value != undefined) {
      if (!this.options) this.options = {};
      if (!this.options.plugins) this.options.plugins = {};
      if (!this.options.plugins.title) this.options.plugins.title = {};

      this.options.plugins.title.display = value;
    }
  };

  @Input() noContentTitle = $localize`:Stats|Stats missing title@@stats-missing-title:No statistical data available at the moment`;
  @Input() noContentDetails = '';

  @Input() labels: string[] = [];

  dataset: ChartDataset<'bar'>[] = [];
  chartData?: number[];

}
